import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-accept-modal',
  templateUrl: './accept-modal.component.html',
  styleUrls: ['./accept-modal.component.scss']
})
export class AcceptModalComponent implements OnInit {
  dialogResponse: any = {
    isOkay: false,
    isSN : true,
    isClose: false,
    showButtons: true,
    hasOrderParts: false,
    customString : null
  };
 showButtons = true
  constructor(@Inject(MAT_DIALOG_DATA) private data: any, ) { }


  ngOnInit() {
    this.dialogResponse = this.data;
    this.showButtons = (this.data?.showButtons || this.data?.showButtons == false) ? this.data?.showButtons : true;
  }

}
